import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import { ReactElement, useState } from 'react';
import { ProductCollectionResource } from '../../../Types';
import ExpandButton from './ExpandButton';

interface Props {
  productCollection: ProductCollectionResource;
  children: ReactElement;
}

function ProductCollectionDisplay({ productCollection, children }: Props) {
  const [expanded, setExpanded] = useState(false);

  return productCollection.payload.display_button_label
    .andThen(when(!expanded))
    .map((label) => (
      <ExpandButton displayButtonLabel={label} onShowExperiences={() => setExpanded(true)} />
    ))
    .getOrElse(() => <>{children}</>);
}

export default observer(ProductCollectionDisplay);
